import { create } from 'zustand';

import type { NoteInput } from '@/schemas/note';
import type { TaskInput } from '@/schemas/task';

export interface AssistantEventDraft {
  title: string;
  description?: string;
  event_type: 'meeting' | 'filing_deadline' | 'legal_review' | 'earnings_date' | 'internal_reminder';
  starts_at?: string;
  ends_at?: string;
  reminder_at?: string;
  company_id?: string | null;
}

export interface AssistantBriefingDraft {
  title: string;
  content: string;
  sourcePrompt?: string;
}

interface AssistantState {
  runtimeInfo: AppAiRuntimeInfo | null;
  assistantOpen: boolean;
  threadId: string;
  currentRoute: string | null;
  noteDraft: Partial<NoteInput> | null;
  taskDraft: Partial<TaskInput> | null;
  eventDraft: AssistantEventDraft | null;
  briefingDraft: AssistantBriefingDraft | null;
  setRuntimeInfo: (info: AppAiRuntimeInfo) => void;
  setAssistantOpen: (open: boolean) => void;
  setCurrentRoute: (route: string | null) => void;
  setNoteDraft: (draft: Partial<NoteInput> | null) => void;
  setTaskDraft: (draft: Partial<TaskInput> | null) => void;
  setEventDraft: (draft: AssistantEventDraft | null) => void;
  setBriefingDraft: (draft: AssistantBriefingDraft | null) => void;
  resetThread: () => void;
  clearDrafts: () => void;
}

export const useAssistantStore = create<AssistantState>((set) => ({
  runtimeInfo: null,
  assistantOpen: false,
  threadId: crypto.randomUUID(),
  currentRoute: null,
  noteDraft: null,
  taskDraft: null,
  eventDraft: null,
  briefingDraft: null,
  setRuntimeInfo: (runtimeInfo) => set({ runtimeInfo }),
  setAssistantOpen: (assistantOpen) => set({ assistantOpen }),
  setCurrentRoute: (currentRoute) => set({ currentRoute }),
  setNoteDraft: (noteDraft) => set({ noteDraft }),
  setTaskDraft: (taskDraft) => set({ taskDraft }),
  setEventDraft: (eventDraft) => set({ eventDraft }),
  setBriefingDraft: (briefingDraft) => set({ briefingDraft }),
  resetThread: () => set({ threadId: crypto.randomUUID() }),
  clearDrafts: () =>
    set({
      noteDraft: null,
      taskDraft: null,
      eventDraft: null,
      briefingDraft: null,
    }),
}));
